import React from 'react';
import { Paper, Box, Grid } from '@mui/material';
import OrderForm from '../components/OrderForm';

export default function OrderDetails() {
    return <OrderForm />;
}
